
/**
 * Apply environmental properties to Skiiers.
 *
 * @type {Object}
 */
Game.Utils.MapEnvironment = {


	/**
	 * Execute the environment effects.
	 *
	 * @param  {Skier} skier The skier that will be affected by the environment.
	 */
	run: function( man ) {

		// Reset the players height.
		man.tile_height = 0;

		// Get the current tile data, and the tile id.
		var tile = Game.Utils.Map.get_tile( man.x, man.y, Game.Utils.Map.layer_properties );
		var tile_id = tile.index;

		// Quit if the tile has no interesting features.
		if ( tile_id <= 0 ) {
			return;
		}

		// Check for an action method for the current tile.
		if ( 'function' === typeof this[ 'overlap_' + tile_id ] ) {
			this[ 'overlap_' + tile_id ]( man, tile );
		}

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_992: function( man ) {

		man.tile_height = 3;
		man.body.velocity.y += 0.3;

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_991: function( man ) {

		man.tile_height = 2;
		man.body.velocity.y += 0.2;

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_990: function( man ) {

		man.tile_height = 1;
		man.body.velocity.y += 0.1;

	},


	/**
	 * Water - drown.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_989: function( man, tile ) {

		var skier_size = 2;

		if ( ( man.y - skier_size ) > tile.worldY && ( man.y + skier_size ) < ( tile.worldY + Game.Utils.Map.TILE_SIZE ) ) {

			// Nest the checks so that we don't have to do them if the first is false.
			// Check left.
			if ( Game.Utils.Map.point_overlap_water( man.x - skier_size, man.y ) ) {

				// Check right.
				if ( Game.Utils.Map.point_overlap_water( man.x + skier_size, man.y ) ) {

					Game.Utils.Audio.play( 'splash' );
					man.death_drown();

				}

			}

		}

	},


	/**
	 * Ski faster.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_988: function( man ) {

		man.body.velocity.y += 1;

	},


	/**
	 * Weeeeee.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_987: function( man ) {

		man.body.velocity.y += 1.5;

		Game.Utils.Audio.play( 'weeeee' );

	},


	/**
	 * Disable the ski trail.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_986: function( man ) {

	},


	/**
	 * Ski super fast.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_985: function( man ) {

		man.body.velocity.y += 2;

	},


	/**
	 * Coin.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_984: function( man ) {



	},

};
